// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4e9d95d3","594":"4344bc18"}[chunkId] + ".chunk.js";
};